<template>
  <div class="accountManagement">
    <header>
      <el-button
        type="primary"
        style="margin-right: 30px;"
        @click="getURLData"
      >授权</el-button>
      <el-input
        v-model="wechatAccountsQuery.wechat_account_name"
        style="max-width: 200px; margin-right: 18px"
        placeholder="公众号名称"
      />
      <!-- <el-select
        v-model="wechatAccountsQuery.delivery_person"
        filterable
        placeholder="投放者"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.user : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.platform"
        filterable
        placeholder="平台"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.platform : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.novel_name"
        filterable
        placeholder="小说"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.novel : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.lead"
        filterable
        placeholder="主角"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.lead : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select> -->
      <el-select
        v-model="wechatAccountsQuery.status"
        placeholder="状态"
      >
        <el-option
          key="1"
          label="启用"
          value="1"
        />
        <el-option
          key="0"
          label="禁用"
          value="0"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="handleReset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="selectData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="account_name"
          label="公众号"
        />
        <el-table-column
          prop="app_id"
          label="Appid"
        />
        <el-table-column
          prop="status"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-show="scope.row.status === 1">正常</el-tag>
            <el-tag
              v-show="scope.row.status === 2"
              type="info"
            >解绑</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="50"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              style="margin-top:5px; margin-right: 5px"
              @click="accountReplyConfig(scope.row)"
            >关注回复信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <pagination-right
      :total="selectData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <global-window
      title="授权"
      :visible.sync="dialogVisible"
      :show="true"
      width="1000px"
      @close="closeDialog"
      @confirm="closeDialog"
    >
      <iframe
        v-if="iframeURL === null ? false : true"
        width="960"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </global-window>
    <el-dialog
      title="公众号配置回复信息"
      :visible.sync="dialogVisibleFollow"
      width="800px"
    >
      <accountReplyConfig
        ref="config"
        @handupdata="handupdata"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getList, getURL, update_or_create } from '@/api/report/accountManagement'
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import accountReplyConfig from './accountReplyConfig.vue'
export default {
  name: 'AccountManagement',
  components: {
    PaginationRight,
    GlobalWindow,
    accountReplyConfig
  },
  data() {
    return {
      tableData: {},
      flag: false,
      authorizeURL: null,
      wechatAccountsQuery: {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      },
      selectData: {}, // 列表数据，包括筛选条件数据
      loading: null, // 加载效果
      iframeURL: null,
      dialogVisible: false,
      dialogVisibleFollow: false
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (!newValue) {
        this.iframeURL = null
      }
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    async handupdata(obj) {
      const res = await update_or_create(obj)
      if (res.success) {
        this.dialogVisibleFollow = false
        this.getListData()
      }
    },
    accountReplyConfig(row) {
      this.dialogVisibleFollow = true
      this.$nextTick(() => {
        this.$refs.config.sendr(row)
      })
    },
    // 获取列表数据，包括筛选条件列表
    getListData() {
      this.loading = true
      getList(this.wechatAccountsQuery).then(res => {
        this.selectData = res.data
        this.loading = false
      })
    },
    // 跳转到授权页面
    getURLData() {
      this.dialogVisible = true
      getURL().then(res => {
        this.iframeURL = res.data.wechat
        // window.open(res.data)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.iframeURL = null
    },
    // 搜索小说
    handleSearch() {
      this.wechatAccountsQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    handleReset() {
      this.wechatAccountsQuery = {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      }
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatAccountsQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.wechatAccountsQuery.page = e
      this.getListData()
    },

    convertAdvertisers(advertiser_id) {
      if (!advertiser_id) {
        return null
      }
      const s = advertiser_id.map(item => `${item.account_id}(${item.account_name})`)
      let news = null
      if (s.length > 3) {
        news = s.slice(0, 3)
        news.push('...')
      }

      return news ? news.join('\n') : s.join('\n')
    }
  }
}
</script>

<style scoped lang="less">
.accountManagement {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
<style>
.aa {
  white-space: break-spaces;
}
</style>

